import { render, staticRenderFns } from "./Medicineslist.vue?vue&type=template&id=cea87466&scoped=true&"
import script from "./Medicineslist.vue?vue&type=script&lang=js&"
export * from "./Medicineslist.vue?vue&type=script&lang=js&"
import style0 from "./Medicineslist.vue?vue&type=style&index=0&id=cea87466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea87466",
  null
  
)

export default component.exports